<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">视频初始化</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			调用人脸检测接口（SKFaceVideoTrackInit）前必须先成功调用该接口，完成视频检测参数的设置。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public boolean SKFaceVideoTrackInit(int Width, int Height, int Model, boolean Mirroring, int AngelRotation , boolean StrangerShortMemory)</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">（1）Width: 视频流数据宽度</p>
             <p class="doc_main_p">（2）Height: 视频流数据宽度</p>
             <p class="doc_main_p">（3）Model: 数据模式
                                            （0：人脸框、姿态角度（0为默认值）；
                                            1：人脸框、姿态角度、属性；
                                            2：人脸框、姿态角度、72个关键点；
                                            3：人脸框、姿态角度、属性、72个关键点）
            </p>
            <p class="doc_main_p">（4）Mirroring：是否需要镜像</p>
            <p class="doc_main_p">（5）AngelRotation：图像旋转角度
                                           （0：不旋转，默认值；
                                            1：顺时针旋转90度；
                                            2：顺时针旋转180度；
                                            3：顺时针旋转270度；）
            </p>
             <p class="doc_main_p">（6）StrangerShortMemory：是否开启陌生人短时记忆功能（true：开启，false：不开启（默认值））
不开启：识别到“陌生人”，Name会返回“陌生人”
开启后：识别到“陌生人”，Name会返回“[StrangerID]”，例如“[00000001]”、“[00000002]”，表示“陌生人1”、“陌生人2”
</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">boolean类型，视频初始化结果，成功为true，失败为false，成功后则可以调用Video人脸检测
</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">boolean initRes = skFace.SKFaceVideoTrackInit(cameraSize.width, cameraSize.height, 3 , false,0);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceFamily-Android','视频接口','视频初始化'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/SKFaceSDKFamily/voideinitiali/VoideInitialization.vue